import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop
 * Al navegar entre rutas SPA, resetea la posición de scroll al top.
 * Sin esto la posición se mantiene entre rutas → mala UX en mobile
 * (ej. tocar card en /catalogo → ProductoDetalle abre a mitad de página).
 *
 * Uso: montar UNA vez dentro de <BrowserRouter>, antes de <Routes>.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // 'instant' evita el smooth scroll molesto al cambiar de página.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}

export default ScrollToTop
